import React, {useRef, useState} from 'react';
import {useAuth} from "../context/AuthContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link, useNavigate} from "react-router-dom";

const Signup = () => {
    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const {signup, currentUser} = useAuth()
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (passwordRef.current.value !== passwordConfirmRef.current.value) {
            return setError('Parol mos kelmadi!')
        }

        try {
            setError('')
            setLoading(true)
            await signup(emailRef.current.value, passwordRef.current.value)
            navigate('/')
        } catch (e) {
            console.log(e)
            setError("Ro'yxatdan o'tishda xatolik yuz berdi!!!")
        }
        setLoading(false)
    }

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{minHeight: "100vh"}}>
            <div className="card p-4 w-100" style={{maxWidth: "450px", marginTop: "-15%"}}>
                {currentUser && currentUser.email}
                <h4 className="text-center mb-4">MWR DATA</h4>
                {error && (
                    <div className="alert alert-danger py-2" role="alert">
                        <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /> {error}
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label" >E-Manzil</label>
                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" ref={emailRef} />
                        {/*<div id="emailHelp" className="form-text text-danger">We'll never share your email with anyone else.</div>*/}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputPassword1" className="form-label" >Parol</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" ref={passwordRef} />
                        {/*<div id="emailHelp" className="form-text text-danger">We'll never share your email with anyone else.</div>*/}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputPassword2" className="form-label">Parolni qayta tering</label>
                        <input type="password" className="form-control" id="exampleInputPassword2" ref={passwordConfirmRef} />
                        {/*<div id="emailHelp" className="form-text text-danger">We'll never share your email with anyone else.</div>*/}
                    </div>
                    <button disabled={loading} type="submit" className="btn btn-primary w-100">Ro'yxatdan o'tish</button>
                    <p className="text-center mt-3">Ro'yxatdan o'tganmisiz? <Link to='/signin'>Login</Link></p>
                </form>
            </div>
        </div>
    );
};

export default Signup;